import type { ReactNode } from "react";

export function FieldRow({
  label,
  hint,
  children,
  className,
  layout = "inline",
}: {
  label: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
  className?: string;
  layout?: "inline" | "stacked";
}) {
  return (
    <div
      className={[
        "ui-field-row",
        layout === "stacked" && "ui-field-row--stacked",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="ui-field-row__copy">
        <div className="ui-field-row__label">{label}</div>
        {hint && layout === "inline" && (
          <div className="ui-field-row__hint">{hint}</div>
        )}
      </div>
      <div className="ui-field-row__control">{children}</div>
      {hint && layout === "stacked" && (
        <div className="ui-field-row__hint">{hint}</div>
      )}
    </div>
  );
}
